import { Navigate, Route, Routes } from "react-router-dom";
import { RequireAuth } from "./components/RequireAuth.js";
import { AuthForm } from "./pages/AuthForm.js";
import { Documents } from "./pages/Documents.js";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<AuthForm mode="login" />} />
      <Route path="/register" element={<AuthForm mode="register" />} />

      <Route
        path="/documents"
        element={
          <RequireAuth>
            <Documents />
          </RequireAuth>
        }
      />

      <Route path="/" element={<Navigate to="/documents" replace />} />
      {/* Any unknown path lands somewhere sensible rather than a blank screen.
          Reaching this route at all depends on public/_redirects serving
          index.html for paths that are not files (W-2). */}
      <Route path="*" element={<Navigate to="/documents" replace />} />
    </Routes>
  );
}
